// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-8e38a55c] .sortable-ghost{opacity:.7;border-radius:var(--border-radius-large);background-color:var(--color-background-hover)}`, "",{"version":3,"sources":["webpack://./src/components/PageList/Draggable.vue"],"names":[],"mappings":"AAEA,kCACC,UAAA,CACA,wCAAA,CACA,8CAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
